import { FC, PropsWithChildren } from 'react';
import sanitizer from '@helpers/sanitizer';
import classNames from 'clsx';
import { useTranslation } from 'next-i18next';
import { useContextSelector } from 'use-context-selector';
import { PriceDropContext } from '@context/price-drop-context';
import SoldProductSlider from '@components/organisms/product-block/product-slider/sold-product-slider';
import styles from './sold-products-frame.module.scss';

export type FCWithChildren<T = {}> = FC<PropsWithChildren<T>>;

export const SoldProductsFrame: FCWithChildren<{
  className?: string;
}> = ({ className }) => {
  const { t } = useTranslation('price-drop');
  const similarSoldProducts = useContextSelector(PriceDropContext, (a) => a.similarSoldProducts);
  const condition = similarSoldProducts[0]?.status;

  return (
    similarSoldProducts &&
    similarSoldProducts.length > 0 && (
      <aside className={classNames(className, styles.soldProductsFrame)}>
        <div className={classNames('innerContainer', styles.soldProductsFrame__wrapper)}>
          <h2 className={classNames(styles.soldProductsFrame__title, 'vc-heading-A32')}>
            {t('PRICE_DROP.SOLD_SIMILAR_ITEM.TITLE')}
          </h2>
          <div className={styles.soldProductsFrame__description}>
            <span
              className={styles.similarItems__conditionDescription}
              dangerouslySetInnerHTML={{
                __html: sanitizer(t('PRICE_DROP.SOLD_SIMILAR_ITEM.CONDITION', { condition: condition })),
              }}
            />
          </div>
          <SoldProductSlider products={similarSoldProducts} />
        </div>
      </aside>
    )
  );
};
